var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgMairie = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24.982,
    height: 19.606,
    viewBox: "0 0 24.982 19.606",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "reserver",
    transform: "translate(-3376 -5844.61)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_88991",
    "data-name": 88991,
    transform: "translate(3376 5801.863)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_56",
    "data-name": "Trac\\xE9 56",
    d: "M22.829,74.724l1.262-1.262H16.233v1.262h6.6Z",
    transform: "translate(-15.212 -28.783)",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_57",
    "data-name": "Trac\\xE9 57",
    d: "M263.433,74.724h.481V73.462h-7.858l1.262,1.262Z",
    transform: "translate(-239.953 -28.783)",
    fill: "#5471a9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_58",
    "data-name": "Trac\\xE9 58",
    d: "M24.081,60.179h-.6V46.541H17.116l-3.794-3.794H11.66L7.866,46.541H1.5V60.179H0v2.173H24.982V60.179ZM4.7,58.611H3.018V54.227H4.7Zm0-6.005H3.018V48.222H4.7Zm7.151,6.766H8.327V51.7h3.523ZM10.584,47.987a1.907,1.907,0,1,1,1.907,1.907A1.907,1.907,0,0,1,10.584,47.987Zm6.07,11.385H13.132V51.7h3.523Zm5.31-.761H20.283V54.227h1.682Zm0-6.005H20.283V48.222h1.682Z",
    transform: "translate(0 0)",
    fill: "#5471a9"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgMairie, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/mairie.20addd7c.svg";
export { ForwardRef as ReactComponent };